import { render, staticRenderFns } from "./CasesCustomFields.vue?vue&type=template&id=745f7a22&"
import script from "./CasesCustomFields.vue?vue&type=script&lang=js&"
export * from "./CasesCustomFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports